import { Avatar } from "antd";
import RestrictionBanner from "common/RestrictionBanner";
import NotificationButton from "features/notifications/elements/NotificationButton";
import { useNotifications } from "features/notifications/useNotifications";
import { isSeverelyRestricted } from "features/restrictions/utils";
import { useFlag } from "hooks/useFlags";
import { useHeaderHeightVar } from "hooks/useHeaderHeightVar";
import { useTexts } from "hooks/useTexts";
import { useUser } from "hooks/useUser";
import React, { useRef } from "react";

import { apiHost } from "../consts";

import "./header.css";

const LINK_BASE_URL = apiHost;

const Header: React.FC = () => {
  const { txt } = useTexts("site_menu");

  const { person, isLoggedIn, restrictions } = useUser();

  const notificationsEnabled = useFlag("notificationsTest");
  const { count: notificationCount } = useNotifications();

  const headerRef = useRef<HTMLElement>(null);

  useHeaderHeightVar(headerRef);

  const avatarUrl =
    person?.avatarUrl || "https://randomuser.me/api/portraits/lego/1.jpg";

  return (
    <header
      ref={headerRef}
      className="site-header"
      role="banner"
    >
      <div className="wrap">
        <div className="brand">
          <a href="https://peresoberem.org/">
            <img
              src="https://peresoberem.org/_assets/v11/3a97bd46bb74c7dc216ec14cddada11e37d2c606.svg"
              alt={txt("logo_alt", "пересоберём")}
            />
          </a>
        </div>

        <nav>
          <a href="https://peresoberem.org/">{txt("main", "Главная")}</a>
          <a href="/">{txt("catalog", "Каталог кейсов")}</a>
          <a href="https://peresoberem.org/rules">{txt("rules", "Правила")}</a>
        </nav>

        <div
          className="spacer"
          aria-hidden="true"
        ></div>

        <div className="actions">
          {isLoggedIn ? (
            <>
              <a
                className="profile-link"
                role="link"
                href="/#/profile"
              >
                {txt("profile", "Профиль")}{" "}
                <Avatar
                  size="large"
                  src={avatarUrl}
                />
              </a>
              {notificationsEnabled && (
                <NotificationButton count={notificationCount} />
              )}
              <a
                className="btn btn-accent"
                href={`${LINK_BASE_URL}/solutions/logout/`}
              >
                {txt("logout", "Выйти")}
              </a>
            </>
          ) : (
            <>
              <a
                className="btn btn-ghost"
                href={`${LINK_BASE_URL}/solutions/signup/`}
              >
                {txt("signup", "Регистрация")}
              </a>
              <a
                className="btn btn-accent"
                href={`${LINK_BASE_URL}/solutions/login/`}
              >
                {txt("login", "Войти")}
              </a>
            </>
          )}
        </div>
      </div>

      {isSeverelyRestricted(restrictions) && (
        <RestrictionBanner restrictions={restrictions} />
      )}
    </header>
  );
};

export default Header;
